'use strict';

var ViewportLegendDirective = function ViewportLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/viewport-legend.html'),
    link: function link(scope, element) {
      element.find('.viewport-help-icon').popover();
    }
  };
};
ViewportLegendDirective.$inject = [];
module.exports = ViewportLegendDirective;